export enum PostClosingStatus {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
  InProgress = 'in_progress',
  NeedsQcReview = 'needs_qc_review'
}
